export default __webpack_public_path__ + "static/media/GR.8d47a64b.jpg";